(function() {
  $(document).ready(function() {
    if(window.location.href.includes("refer")){
      $(".breadcrumb").remove();
    }
    $(document).on("click", ".swell-share-referral-copy", function() {
      setTimeout(function(){
        detachReferralCopy();
        $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("http://",""));
        $(".swell-referral-details").append(".");
      },20);
    });
    $(document).on("click", ".swell-down-refer", function() {
      var scroll_position = 0;
      if($(window).width() < 540) {
        scroll_position = 40;
      }
      $('html, body').animate({
        scrollTop: $("#referral-holder-div").offset().top-scroll_position
      }, 1000);
    });
    $('body').on('click', '.swell-referral-back-link.checkout', function(e){
      $(".hobobags-rewards").hide();
    });
    $('body').on('click', '.swell-referral-back-link', function(e){
      $(".swell-referral").removeClass("thankyou");
      $(".swell-referral-sidebar-details").show();
      $(".refer-a-friend").removeClass("hide");
    });
    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
        $(".refer-customer-error").remove();
        $(".refer-a-friend").removeClass("hide");
        $(".swell-referral-sidebar-details").show();
        $(".swell-referral").removeClass("thankyou");
        $(".swell-referral-content-container").addClass("error-message");
        $("#swell-referral-refer-emails").addClass("error-border");
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }
      else if(textStatus && textStatus === "Please enter a valid email address"){
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      }
    });
    $(document).on("swell:setup", function() {
      $(".swell-load").remove();

      if($(".swell-referral").length>0){
        SwellConfig.Referral.initializeReferral(".swell-referral");
        if(spapi.authenticated || (spapi.customer.referral_receipts && spapi.customer.referral_receipts.length > 0)) {
          setupReferrals();
        }
        $(document).on("swell:referral:success", function(jqXHR, textStatus, errorThrown) {
          thankyou();
        });
        $('body').on('click', '.swell-referral-copy', function(e){
          if($(e.target).hasClass("swell-referral-copy")) {
            e.stopPropagation();
          }
        });
        $(document).on('click', '.swell-referral-form-field-details.swell-icon-arrow', function(){
          $(".swell-referral-form-list-submit").click();
        });
        $(".hobobags-rewards").css("display","flex");
      }
    });
  });
}).call(this);

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "share the leather love",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Your email",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "share the leather love",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Enter your friends’ emails.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share the link with<br class='swell-mobile'> the buttons below.",

        referralShareFacebook: "Share",
        referralShareCopy: "Copy Link",
        referralShareSMS: "SMS",
        referralShareMessenger: "Message",

        referralFacebookIcon: "swell-icon-facebook",
        referralLinkIcon: "swell-icon-copy",
        referralSMSIcon: "swell-icon-sms",
        referralMessengerIcon: "swell-icon-message",

        referralThanksHeading: "thank you!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends"
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralRegisterDetails %></p></div><div class="middle-border"></div><div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" class="swell-referral-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> <span class="swell-referral-form-field-details swell-icon-arrow"></span> </li> <li class="swell-referral-form-list-button"> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </div> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralReferDetails %></p></div><div class="middle-border"></div><div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details swell-icon-arrow"></span> </li> <li class="swell-referral-form-list-button"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i><%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-sms" aria-hidden="true"></i>SMS</div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i><%= localization.referralShareMessenger %></div> </li> <li class=\"swell-referral-medium swell-share-referral-twitter\"> <div class="swell-referral-medium-content"> <i class=\"swell-icon-tweet\" aria-hidden=\"true\"></i>Tweet</div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i><%= localization.referralShareCopy %></div> </li> </ul> </div> </div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      $(".swell-referral").show();
    }
  };
}).call(this);

function setupReferrals(){
  $(".swell-referral-content").show();
  $(".border").show();
  if(spapi.customer.referral_receipts.length > 0) {
    $(".referral-table").show();
    referrals = spapi.customer.referral_receipts;

    referrals.forEach(function(referral) {
      status = null;

      if(referral.completed_at){ 
        status = "Purchased ("+spapi.activeReferralCampaign.prettyReward+" earned)";
      } else {
        status = "Invited";
      }

      $(".swell-referral-table tbody").append('<tr> <td> <div class="trucate-email">' +  referral.email + '</div></td><td>' + status +'</td></tr>');
    });  
  }
}

function detachReferralCopy(){
  if($(".swell-referral-copy").length > 0){
    $("body").append($(".swell-referral-copy").detach());
  }
}

function thankyou(){
  $(".refer-a-friend").addClass("hide");
  $(".swell-referral-sidebar-details").hide();
  $(".swell-referral").addClass("thankyou");
  swellAPI.refreshCustomerDetails(function(){
    $(".swell-referral-table tbody").html("");
    referrals = spapi.customer.referral_receipts;
    referrals.forEach(function(referral) {
      status = null;

      if(referral.completed_at){ 
        status = "Purchased ("+spapi.activeReferralCampaign.prettyReward+" earned)";
      } else {
        status = "Invited";
      }

      $(".swell-referral-table tbody").append('<tr> <td> <div class="trucate-email">' +  referral.email + '</div></td><td>' + status +'</td></tr>');
    });
  });
}
